/**@todo should we turn this into an env variable instead? */
export const PENDO_SWA_API_KEY = 'c9aba383-6ca4-4cfd-40ec-47bce5e8e93d'
